module.exports = __webpack_public_path__ + "img/ereszkalkulator_kicsi_haz_osszetett_nyeregteto_szurke.6f27bdb3.png";